import { useEffect, useRef } from 'react'
import Cartao from './Cartao.js'

const Carrocel = (props) => {
    const carrocelRef = useRef(null)

    //retorna para o primeiro cartão
    useEffect(()=>{
        if(carrocelRef.current){
            carrocelRef.current.scrollTo({ left: 0, behavior: 'smooth'})
        }
    }, [props.selectData, props.selectValor])

    return(
        <div ref={carrocelRef} className="flex flex-row w-full px-12 gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory scroll-smooth">
            {props.roles.map((item) => {
                if(props.locais.find((elemento) => elemento.cep == item.cep && elemento.numero == item.numero)){
                    return(
                        <Cartao key={item.nome} role={item} locais={props.locais} />
                    )
                }
            })}
        </div>
    )
}

export default Carrocel